export const selectRoles = (state) => state.roles?.roles || [];
export const selectRoleLoading = (state) => state.roles?.loading || false;
export const selectRoleError = (state) => state.roles?.error || null;
export const selectSelectedRole = (state) => state.roles?.selectedRole || null;

// Additional useful selectors
export const selectActiveRoles = (state) =>
  state.roles?.roles?.filter((role) => role.status === "active") || [];
export const selectSystemRoles = (state) =>
  state.roles?.roles?.filter((role) => role.is_system === 1) || [];
export const selectTenantRoles = (state, tenantId) =>
  state.roles?.roles?.filter((role) => role.tenant_id === tenantId) || [];
export const selectRoleById = (state, roleId) =>
  state.roles?.roles?.find((role) => role.id === roleId) || null;
